module.exports = __webpack_public_path__ + "img/banner24-3.cbcef1bc.jpg";